// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Guide.css — responsive overrides for src/pages/Guide.jsx
   Loads AFTER index.css; wins by source order at equal specificity.
   Breakpoints: mobile <=576px | tablet 577-991px | laptop 992-1280px | desktop >=1281px
   ============================================================ */

/* ---- Tablet (<=991px): shrink sidebar, reduce main padding ---- */
@media (max-width: 991px) {
  .guide-main {
    padding: 1.25rem 1.25rem;
    max-width: 100%;
  }
}

/* ---- Mobile (<=576px): full responsive treatment ---- */
@media (max-width: 576px) {
  /* Page layout: stack sidebar above content */
  .guide-page {
    flex-direction: column;
    gap: 12px;
  }

  /* Sidebar becomes a collapsible top strip */
  .guide-sidebar {
    width: 100% !important;
    position: static;
    overflow: visible;
  }

  /* Nav toggle button — shown only on mobile */
  .guide-nav-toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0.75rem 0.5rem 0;
    background: none;
    border: none;
    color: var(--ink);
    font-size: 0.875rem;
    font-weight: 600;
    cursor: pointer;
    min-height: 44px;
    font-family: var(--iv-sans);
  }

  .guide-nav-toggle-label {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: var(--ink-muted);
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }

  .guide-nav-toggle-active {
    color: var(--accent-ink);
    font-weight: 600;
    font-size: 0.875rem;
    text-transform: none;
    letter-spacing: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 70%;
  }

  .guide-nav-toggle-chevron {
    transition: transform 0.2s ease;
    flex-shrink: 0;
    color: var(--ink-muted);
  }

  .guide-nav-toggle-chevron.open {
    transform: rotate(90deg);
  }

  /* Nav list: hidden by default, shown when open */
  .guide-nav {
    display: none !important;
    flex-direction: column !important;
    padding: 0.5rem 0 0;
    margin-top: 0.5rem;
    border-top: 1px solid var(--line);
  }

  .guide-nav.nav-open {
    display: flex !important;
  }

  /* Nav items: restore label text on mobile, full-width rows */
  .guide-nav-item {
    flex: none;
    width: 100% !important;
    min-height: 44px;
    padding: 0.625rem 0.75rem;
  }

  .guide-nav-item span {
    display: inline !important; /* override the 768px rule that hides labels */
  }

  /* Main content: tighter padding, single column */
  .guide-main {
    padding: 18px 16px;
    max-width: 100%;
    overflow-x: hidden;
  }

  .guide-content h1 {
    font-size: 1.3rem;
  }

  .guide-content .intro {
    font-size: 0.9rem;
  }

  /* Grids: single column */
  .steps-grid {
    grid-template-columns: 1fr !important;
  }

  .options-grid {
    grid-template-columns: 1fr !important;
  }

  .status-grid,
  .status-grid.compact {
    grid-template-columns: 1fr !important;
  }

  .key-types {
    grid-template-columns: 1fr !important;
  }

  /* Tables: horizontal scroll container to prevent page overflow */
  .comparison-table,
  .params-table {
    display: block;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    white-space: nowrap;
  }

  /* Code blocks: horizontal scroll, no page overflow */
  .guide-code pre {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .guide-code code {
    font-size: 0.72rem;
  }

  /* Endpoint display: allow wrapping */
  .endpoint {
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .endpoint code {
    word-break: break-all;
    white-space: normal;
    font-size: 0.8rem;
  }

  /* Info boxes: ensure icon doesn't get squeezed */
  .info-box {
    align-items: flex-start;
  }

  /* Option card buttons: ensure >=44px tap target */
  .option-card button {
    min-height: 44px;
    padding: 0.5rem 0;
  }

  /* Copy button: ensure comfortable tap target */
  .guide-code .rd-copy {
    min-height: 32px;
    padding: 0.3125rem 0.625rem;
  }

  /* Numbered list: keep left padding comfortable */
  .numbered-list li {
    padding-left: 2.5rem;
  }

  /* Status items: consistent spacing */
  .status-item {
    padding: 0.875rem;
  }

  /* Check items: ensure text wraps properly */
  .check-item span {
    font-size: 0.875rem;
    line-height: 1.5;
  }

  /* Guide sidebar header */
  .guide-sidebar-header {
    padding: 1rem;
  }
}

/* ---- Tablet and above: toggle button hidden, nav always visible ---- */
@media (min-width: 577px) {
  .guide-nav-toggle {
    display: none;
  }

  /* Undo the mobile hidden-by-default so the nav is always visible at tablet+ */
  .guide-nav {
    display: flex !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/responsive/pages/Guide.css"],"names":[],"mappings":"AAAA;;;;iEAIiE;;AAEjE,oEAAoE;AACpE;EACE;IACE,wBAAwB;IACxB,eAAe;EACjB;AACF;;AAEA,0DAA0D;AAC1D;EACE,6CAA6C;EAC7C;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA,4CAA4C;EAC5C;IACE,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA,6CAA6C;EAC7C;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;EAChB;;EAEA;IACE,+BAA+B;IAC/B,cAAc;IACd,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,iDAAiD;EACjD;IACE,wBAAwB;IACxB,iCAAiC;IACjC,mBAAmB;IACnB,kBAAkB;IAClB,iCAAiC;EACnC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,6DAA6D;EAC7D;IACE,UAAU;IACV,sBAAsB;IACtB,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B,EAAE,8CAA8C;EAC5E;;EAEA,iDAAiD;EACjD;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,yBAAyB;EACzB;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;;IAEE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA,iEAAiE;EACjE;;IAEE,cAAc;IACd,gBAAgB;IAChB,iCAAiC;IACjC,mBAAmB;EACrB;;EAEA,qDAAqD;EACrD;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,kBAAkB;EACpB;;EAEA,qCAAqC;EACrC;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA,iDAAiD;EACjD;IACE,uBAAuB;EACzB;;EAEA,kDAAkD;EAClD;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA,+CAA+C;EAC/C;IACE,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA,iDAAiD;EACjD;IACE,oBAAoB;EACtB;;EAEA,qCAAqC;EACrC;IACE,iBAAiB;EACnB;;EAEA,4CAA4C;EAC5C;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA,yBAAyB;EACzB;IACE,aAAa;EACf;AACF;;AAEA,yEAAyE;AACzE;EACE;IACE,aAAa;EACf;;EAEA,8EAA8E;EAC9E;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/* ============================================================\n   Guide.css — responsive overrides for src/pages/Guide.jsx\n   Loads AFTER index.css; wins by source order at equal specificity.\n   Breakpoints: mobile <=576px | tablet 577-991px | laptop 992-1280px | desktop >=1281px\n   ============================================================ */\n\n/* ---- Tablet (<=991px): shrink sidebar, reduce main padding ---- */\n@media (max-width: 991px) {\n  .guide-main {\n    padding: 1.25rem 1.25rem;\n    max-width: 100%;\n  }\n}\n\n/* ---- Mobile (<=576px): full responsive treatment ---- */\n@media (max-width: 576px) {\n  /* Page layout: stack sidebar above content */\n  .guide-page {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  /* Sidebar becomes a collapsible top strip */\n  .guide-sidebar {\n    width: 100% !important;\n    position: static;\n    overflow: visible;\n  }\n\n  /* Nav toggle button — shown only on mobile */\n  .guide-nav-toggle {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    padding: 0.75rem 0.5rem 0;\n    background: none;\n    border: none;\n    color: var(--ink);\n    font-size: 0.875rem;\n    font-weight: 600;\n    cursor: pointer;\n    min-height: 44px;\n    font-family: var(--iv-sans);\n  }\n\n  .guide-nav-toggle-label {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    color: var(--ink-muted);\n    font-size: 0.75rem;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n  }\n\n  .guide-nav-toggle-active {\n    color: var(--accent-ink);\n    font-weight: 600;\n    font-size: 0.875rem;\n    text-transform: none;\n    letter-spacing: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 70%;\n  }\n\n  .guide-nav-toggle-chevron {\n    transition: transform 0.2s ease;\n    flex-shrink: 0;\n    color: var(--ink-muted);\n  }\n\n  .guide-nav-toggle-chevron.open {\n    transform: rotate(90deg);\n  }\n\n  /* Nav list: hidden by default, shown when open */\n  .guide-nav {\n    display: none !important;\n    flex-direction: column !important;\n    padding: 0.5rem 0 0;\n    margin-top: 0.5rem;\n    border-top: 1px solid var(--line);\n  }\n\n  .guide-nav.nav-open {\n    display: flex !important;\n  }\n\n  /* Nav items: restore label text on mobile, full-width rows */\n  .guide-nav-item {\n    flex: none;\n    width: 100% !important;\n    min-height: 44px;\n    padding: 0.625rem 0.75rem;\n  }\n\n  .guide-nav-item span {\n    display: inline !important; /* override the 768px rule that hides labels */\n  }\n\n  /* Main content: tighter padding, single column */\n  .guide-main {\n    padding: 18px 16px;\n    max-width: 100%;\n    overflow-x: hidden;\n  }\n\n  .guide-content h1 {\n    font-size: 1.3rem;\n  }\n\n  .guide-content .intro {\n    font-size: 0.9rem;\n  }\n\n  /* Grids: single column */\n  .steps-grid {\n    grid-template-columns: 1fr !important;\n  }\n\n  .options-grid {\n    grid-template-columns: 1fr !important;\n  }\n\n  .status-grid,\n  .status-grid.compact {\n    grid-template-columns: 1fr !important;\n  }\n\n  .key-types {\n    grid-template-columns: 1fr !important;\n  }\n\n  /* Tables: horizontal scroll container to prevent page overflow */\n  .comparison-table,\n  .params-table {\n    display: block;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    white-space: nowrap;\n  }\n\n  /* Code blocks: horizontal scroll, no page overflow */\n  .guide-code pre {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .guide-code code {\n    font-size: 0.72rem;\n  }\n\n  /* Endpoint display: allow wrapping */\n  .endpoint {\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n\n  .endpoint code {\n    word-break: break-all;\n    white-space: normal;\n    font-size: 0.8rem;\n  }\n\n  /* Info boxes: ensure icon doesn't get squeezed */\n  .info-box {\n    align-items: flex-start;\n  }\n\n  /* Option card buttons: ensure >=44px tap target */\n  .option-card button {\n    min-height: 44px;\n    padding: 0.5rem 0;\n  }\n\n  /* Copy button: ensure comfortable tap target */\n  .guide-code .rd-copy {\n    min-height: 32px;\n    padding: 0.3125rem 0.625rem;\n  }\n\n  /* Numbered list: keep left padding comfortable */\n  .numbered-list li {\n    padding-left: 2.5rem;\n  }\n\n  /* Status items: consistent spacing */\n  .status-item {\n    padding: 0.875rem;\n  }\n\n  /* Check items: ensure text wraps properly */\n  .check-item span {\n    font-size: 0.875rem;\n    line-height: 1.5;\n  }\n\n  /* Guide sidebar header */\n  .guide-sidebar-header {\n    padding: 1rem;\n  }\n}\n\n/* ---- Tablet and above: toggle button hidden, nav always visible ---- */\n@media (min-width: 577px) {\n  .guide-nav-toggle {\n    display: none;\n  }\n\n  /* Undo the mobile hidden-by-default so the nav is always visible at tablet+ */\n  .guide-nav {\n    display: flex !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
